import { BCDataGrid } from '@bimser/components';
import { isNullOrUndefined } from '@bimser/core';
import DataGrid2 from '../../..';
import { IComboBoxProperties } from '../../../../ComboBox/entities/IComboBoxProperties';
import { IDataGridColumn } from '../../../entities';
import { EditCellItemComponent } from './EditCellItemComponent';
import { getDataSource } from './setComboBoxDataSource';
import React from 'react';

export function EditCellComponent(props) {
	const dataGrid: DataGrid2 = props.data.column.retrieveDataGridInstance();
	const bcColumn = dataGrid.__getBCColumn<IComboBoxProperties>(props.data.column.name);

	const dataSource = getDataSource(dataGrid, bcColumn);

	const [loading, setLoading] = React.useState(false);
	const selectBoxRef = React.useRef<BCDataGrid.Entities.SelectBoxRef>(null);

	dataGrid.__comboBoxes[props.data.column.name].setLoading = setLoading;

	React.useEffect(() => {
		if (selectBoxRef.current) {
			dataGrid.__comboBoxes[props.data.column.name].comboBox = selectBoxRef.current;
		}
	}, [selectBoxRef.current]);

	const dropDownButtonRender = () => {
		return (
			<BCDataGrid.Components.LoadIndicator
				visible
				height="16px"
				width="16px"
			/>
		);
	};

	const onValueChanged = e => {
		if (isNullOrUndefined(e.value)) {
			props.data.setValue(null);
			return;
		}

		switch (bcColumn.dbType.type) {
			case 'object': {
				props.data.setValue(e.component.option('selectedItem'));
				break;
			}
			case 'string': {
				switch (bcColumn.editControl.valueType) {
					case 'boolean': {
						props.data.setValue(
							e.value === true ? 'True' : e.value === false ? 'False' : null
						);
						break;
					}
					case 'decimal':
					case 'integer': {
						props.data.setValue(e.value?.toString() || null);
						break;
					}
					default: {
						props.data.setValue(e.value);
						break;
					}
				}
				break;
			}
			default: {
				props.data.setValue(e.value);
				break;
			}
		}

		setTimeout(() => {
			refreshRelatedComboBoxes(dataGrid, bcColumn);
		});
	};

	const getDefaultValue = () => {
		const value = props.data.value;

		if (bcColumn.dbType.type === 'string' && !isNullOrUndefined(value)) {
			switch (bcColumn.editControl.valueType) {
				case 'boolean': {
					return value === 'True' ? true : value === 'False' ? false : null;
				}
				case 'decimal':
				case 'integer': {
					return Number(value);
				}
			}
		}

		return value;
	};

	// it is a mandatory solution for the issue below
	// https://supportcenter.devexpress.com/ticket/details/t1278654/editing-mode-row-and-setcellvalue-causes-component-re-creation-in-custom-edit-cell
	const onSelectionChanged = React.useCallback(() => {
		props.data.component.updateDimensions();
	}, []);

	const defaltValue = getDefaultValue();

	return (
		<BCDataGrid.Components.DxSelectBox
			ref={selectBoxRef}
			searchEnabled={bcColumn.editControl.valueType !== 'boolean'}
			dataSource={dataSource}
			itemComponent={EditCellItemComponent}
			onSelectionChanged={onSelectionChanged}
			defaultValue={defaltValue}
			onValueChanged={onValueChanged}
			dropDownButtonRender={loading ? dropDownButtonRender : null}
			valueExpr="value"
			displayExpr="text"
			openOnFieldClick
			deferRendering
			showClearButton
		>
			<BCDataGrid.Components.DropDownOptions
				container={dataGrid.__form.__getShadowRootContainer()}
				maxHeight={300}
			/>
		</BCDataGrid.Components.DxSelectBox>
	);
}

const refreshRelatedComboBoxes = (
	dataGrid: DataGrid2,
	bcColumn: IDataGridColumn<IComboBoxProperties>
) => {
	dataGrid.columns.forEach(column => {
		if (column.editType === 'comboBox') {
			const control = (column as IDataGridColumn<IComboBoxProperties>).editControl;

			if (control.dataSource.name) {
				control.dataSource.parameters.forEach(param => {
					if (
						param.valueModifier == 'fieldSelection' &&
						param.field.includes(`columns.${bcColumn.name}.`)
					) {
						const dataSource = dataGrid.__comboBoxes[column.name];

						if (dataSource) {
							(dataSource.store as BCDataGrid.Components.DataSource).reload();
						}
					}
				});
			}
		}
	});
};
